import { useEffect, useState } from 'react'

import {
  CitizenAddressesAndParcelsSearchInput,
  CitizenAddressesAndParcelsSearchQuery,
  CitizenAddressesAndParcelsSearchQueryVariables,
  UniversalSearchQuery,
  UniversalSearchQueryVariables,
  UniversalSearchRecordFragment as UniversalSearchRecordFragmentType,
} from '../../types/graphql'
import { QueryKey, useQuery } from '../utils/queryClient'

export type UniversalSearchRecordFragment = UniversalSearchRecordFragmentType

const UniversalSearch = gql`
  query UniversalSearchQuery($input: UniversalSearchInput!) {
    universalSearch(input: $input) {
      ...UniversalSearchResultFragment
    }
  }
  fragment UniversalSearchRecordFragment on Record {
    uuid
    id
    tags
    identifier
    displayIdentifier
    isDraft
    issuedIdentifier
    mainBackwardsCompatibleLocationInformation {
      ...BackwardsCompatibleLocationInformationFragment
    }
    organization {
      id
      slug
    }
    recordTemplate {
      id
      name
      recordType {
        id
        displayName
        name
        recordName
      }
    }
  }
  fragment UniversalSearchResultFragment on UniversalSearchResult {
    records {
      ...UniversalSearchRecordFragment
      childRecords(firstX: 3) {
        ...UniversalSearchRecordFragment
      }
    }
    parcels
    addresses
    violations {
      id
      identifier
      address
    }
    addressEntities {
      ...EntityForViewFragment
    }
    parcelEntities {
      ...EntityForViewFragment
    }
  }
`
export const useUniversalSearchQuery = (query: string) => {
  const [placeholderData, setPlaceholderData] = useState<UniversalSearchQuery>()
  const queryResult = useQuery<UniversalSearchQuery, UniversalSearchQueryVariables>({
    queryDocument: UniversalSearch,
    queryKey: [QueryKey.UniversalSearch, query],
    variables: { input: { query } },
    enabled: !!query,
    placeholderData,
  })
  useEffect(() => {
    if (query) {
      setPlaceholderData(queryResult.data)
    } else {
      setPlaceholderData(undefined)
    }
  }, [query, queryResult.data])
  return queryResult
}

const CitizenAddressesAndParcelsSearch = gql`
  query CitizenAddressesAndParcelsSearchQuery($input: CitizenAddressesAndParcelsSearchInput!) {
    citizenAddressesAndParcelsSearch(input: $input) {
      results
    }
  }
`

export const useCitizenAddressesAndParcelsSearchQuery = (
  input: CitizenAddressesAndParcelsSearchInput
) => {
  return useQuery<
    CitizenAddressesAndParcelsSearchQuery,
    CitizenAddressesAndParcelsSearchQueryVariables
  >({
    queryDocument: CitizenAddressesAndParcelsSearch,
    queryKey: [QueryKey.CitizenAddressesAndParcelsSearch, input],
    variables: { input },
    enabled: !!input.query,
  })
}
